<template>
  <v-container class="px-4 pt-0 mt-0"> 

    <!-- Progress Indicator -->
    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-4"></v-progress-linear>

    <!-- Seccion 1: Tarjetas de resumen (KPIs) por Estado Administrativo -->
    <v-row class="mb-0 pb-0">
      <!-- Total General -->
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="elevation-1 border-left-primary clickable-card" @click="abrirDetalle('total')">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption grey--text text--darken-1 font-weight-bold text-uppercase">Total Registros</div>
              <div class="text-h5 font-weight-black primary--text mt-1">{{ datos_ins.length }}</div>
            </div>
            <v-avatar color="blue lighten-5" size="48">
              <v-icon color="primary" large>mdi-account-group</v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Prospectos (id: 1) -->
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="elevation-1 border-left-warning clickable-card" @click="abrirDetalle('prospectos')">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption warning--text text--darken-2 font-weight-bold text-uppercase">Prospectos</div>
              <div class="text-h5 font-weight-black warning--text text--darken-2 mt-1">{{ totalProspectos }}</div>
            </div>
            <v-avatar color="amber lighten-5" size="48">
              <v-icon color="warning text--darken-2" large>mdi-account-clock-outline</v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Preinscritos (id: 2) -->
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="elevation-1 border-left-info clickable-card" @click="abrirDetalle('preinscritos')">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption info--text text--darken-2 font-weight-bold text-uppercase">Preinscritos</div>
              <div class="text-h5 font-weight-black info--text text--darken-2 mt-1">{{ totalPreinscritos }}</div>
            </div>
            <v-avatar color="cyan lighten-5" size="48">
              <v-icon color="info text--darken-2" large>mdi-account-edit-outline</v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Inscritos (id: 3) -->
      <v-col cols="12" sm="6" md="3">
        <v-card outlined class="elevation-1 border-left-success clickable-card" @click="abrirDetalle('inscritos')">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              <div class="text-caption success--text text--darken-2 font-weight-bold text-uppercase">Inscritos</div>
              <div class="text-h5 font-weight-black success--text text--darken-2 mt-1">{{ totalInscritos }}</div>
            </div>
            <v-avatar color="green lighten-5" size="48">
              <v-icon color="success text--darken-2" large>mdi-account-check-outline</v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal Dialog Detalle de Registros -->
    <v-dialog v-model="dialogDetalle" max-width="1100px" scrollable>
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between py-3 px-4 blue darken-3 white--text">
          <span class="text-h6 font-weight-bold">{{ tituloDetalle }} ({{ listaDetalle.length }})</span>
          <v-btn icon dark @click="dialogDetalle = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-2">
          <v-text-field
            v-model="searchDetalle"
            dense
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            label="Buscar..."
            class="mb-2 mt-1"
            hide-details
          />

          <v-data-table
            :headers="headersDetalle"
            :items="listaDetalleFiltrada"
            :search="searchDetalle"
            dense
            :items-per-page="150"
            class="elevation-1 tabla-compacta"
            no-data-text="No hay registros para mostrar"
          >
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:[`item.estudiante_nombre`]="{ item }">
              <span class="font-weight-medium">{{ item.estudiante_nombre || '-' }}</span>
            </template>
            <template v-slot:[`item.programa_nombre`]="{ item }">
              <span>{{ item.programa_nombre || '-' }}</span>
            </template>
            <template v-slot:[`item.asesor_nombre`]="{ item }">
              <span>{{ item.asesor_nombre || '-' }}</span>
            </template>
            <template v-slot:[`item.fecha_inscripcion`]="{ item }">
              <span>{{ formatoFecha(item.fecha_inscripcion) }}</span>
            </template>
            <template v-slot:[`item.estado_administrativo_id`]="{ item }">
              <span>{{ parseInsAdministrativo(item.estado_administrativo_id) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Seccion 2: Podio Top 3 Asesores -->
    <v-row class="mb-4" v-if="false">
      <v-col cols="12">
        <v-card outlined class="elevation-1">
          <v-card-title class="grey lighten-4 py-3 border-bottom">
            <v-icon color="amber darken-2" class="mr-2">mdi-crown</v-icon>
            Top 3 Asesores con Mayor Cantidad de Inscritos
          </v-card-title>
          <v-card-text class="pt-6">
            <div v-if="top3Asesores.length === 0" class="text-center py-6 grey--text">
              <v-icon large color="grey lighten-1">mdi-account-search-outline</v-icon>
              <div class="mt-2">No se encontraron inscritos registrados en el periodo seleccionado.</div>
            </div>

            <v-row v-else align="end" justify="center" class="podium-container">
              <!-- Posicion 2 (Plata) -->
              <v-col cols="12" sm="4" md="3" v-if="top3Asesores[1]" class="order-2 order-sm-1">
                <v-card outlined class="text-center pa-4 podium-card silver-card elevation-2">
                  <v-avatar color="grey lighten-2" size="70" class="mb-3 podium-avatar">
                    <v-icon color="grey darken-2" large>mdi-account</v-icon>
                  </v-avatar>
                  <v-chip color="grey darken-1" dark small class="font-weight-bold mb-2">
                    #2 Lugar
                  </v-chip>
                  <div class="text-subtitle-1 font-weight-bold text-truncate" :title="top3Asesores[1].nombre">
                    {{ top3Asesores[1].nombre }}
                  </div>
                  <div class="text-h5 font-weight-black grey--text text--darken-3 mt-1">
                    {{ top3Asesores[1].inscritos }}
                  </div>
                  <div class="text-caption grey--text">Inscritos</div>
                </v-card>
              </v-col>

              <!-- Posicion 1 (Oro) -->
              <v-col cols="12" sm="4" md="4" v-if="top3Asesores[0]" class="order-1 order-sm-2">
                <v-card outlined class="text-center pa-5 podium-card gold-card elevation-4">
                  <v-avatar color="amber lighten-4" size="85" class="mb-3 podium-avatar">
                    <v-icon color="amber darken-3" class="text-h3">mdi-crown</v-icon>
                  </v-avatar>
                  <br />
                  <v-chip color="amber darken-2" dark class="font-weight-bold mb-2">
                    🥇 #1 Campeón
                  </v-chip>
                  <div class="text-h6 font-weight-bold text-truncate" :title="top3Asesores[0].nombre">
                    {{ top3Asesores[0].nombre }}
                  </div>
                  <div class="text-h3 font-weight-black amber--text text--darken-3 mt-1">
                    {{ top3Asesores[0].inscritos }}
                  </div>
                  <div class="text-caption grey--text font-weight-bold">Inscritos</div>
                </v-card>
              </v-col>

              <!-- Posicion 3 (Bronce) -->
              <v-col cols="12" sm="4" md="3" v-if="top3Asesores[2]" class="order-3">
                <v-card outlined class="text-center pa-4 podium-card bronze-card elevation-2">
                  <v-avatar color="orange lighten-4" size="70" class="mb-3 podium-avatar">
                    <v-icon color="brown darken-1" large>mdi-account</v-icon>
                  </v-avatar>
                  <v-chip color="brown darken-1" dark small class="font-weight-bold mb-2">
                    #3 Lugar
                  </v-chip>
                  <div class="text-subtitle-1 font-weight-bold text-truncate" :title="top3Asesores[2].nombre">
                    {{ top3Asesores[2].nombre }}
                  </div>
                  <div class="text-h5 font-weight-black brown--text text--darken-2 mt-1">
                    {{ top3Asesores[2].inscritos }}
                  </div>
                  <div class="text-caption grey--text">Inscritos</div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Seccion 3: Tabla General de Asesores -->
    <a class="my-0 py-0 pl-2" href="#" @click="ver_tabla_gestionados=!ver_tabla_gestionados">
      <small> ver tabla de los registros </small>
    </a>
    <v-row v-if="ver_tabla_gestionados" class="mt-0 pt-0">
      <v-col cols="12" class="mt-0 pt-0">
        <v-card outlined class="elevation-1">
          <v-card-title class="cyan darken-2 white--text py-0 border-bottom d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon color="white" class="mr-2">mdi-table-account</v-icon>
              <span>Ranking completo de asesores por registros</span>
            </div>
            <v-chip color="primary" small dark class="font-weight-bold">
              {{ rankingAsesoresCompleto.length }} Asesores
            </v-chip>
          </v-card-title>
          <span class="ml-3">Datos segun el estado administrativo de cada participante en la sede y mes actual.</span>
          <v-data-table
            :headers="tablaHeaders"
            :items="rankingAsesoresCompleto"
            :loading="cargando"
            loading-text="Cargando ranking..."
            no-data-text="No hay datos disponibles"
            hide-default-footer
            disable-pagination
            dense
            class="elevation-0"
          >
            <template v-slot:[`item.posicion`]="{ index }">
              <v-chip
                v-if="index === 0"
                color="amber darken-2"
                dark
                x-small
                class="font-weight-bold"
              >
                🥇 1°
              </v-chip>
              <v-chip
                v-else-if="index === 1"
                color="grey darken-1"
                dark
                x-small
                class="font-weight-bold"
              >
                🥈 2°
              </v-chip>
              <v-chip
                v-else-if="index === 2"
                color="brown darken-1"
                dark
                x-small
                class="font-weight-bold"
              >
                🥉 3°
              </v-chip>
              <span v-else class="grey--text text--darken-1 font-weight-medium pl-2">
                {{ index + 1 }}°
              </span>
            </template>
            <template v-slot:[`item.nombre`]="{ item }">
              <span class="font-weight-bold grey--text text--darken-3">{{ item.nombre }}</span>
            </template>
            <template v-slot:[`item.inscritos`]="{ item }">
              <v-chip color="green lighten-5" class="green--text text--darken-3 font-weight-bold" small>
                {{ item.inscritos }}
              </v-chip>
            </template>
            <template v-slot:[`item.preinscritos`]="{ item }">
              <v-chip color="cyan lighten-5" class="cyan--text text--darken-3 font-weight-bold" small>
                {{ item.preinscritos }}
              </v-chip>
            </template>
            <template v-slot:[`item.prospectos`]="{ item }">
              <v-chip color="amber lighten-5" class="amber--text text--darken-3 font-weight-bold" small>
                {{ item.prospectos }}
              </v-chip>
            </template>
            <template v-slot:[`item.total`]="{ item }">
              <span class="font-weight-black text-body-2">{{ item.total }}</span>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.clickable-card {
  cursor: pointer;
  transition: transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.border-left-primary {
  border-left: 5px solid #1976d2 !important;
}
.border-left-warning {
  border-left: 5px solid #fb8c00 !important;
}
.border-left-info {
  border-left: 5px solid #00acc1 !important;
}
.border-left-success {
  border-left: 5px solid #4caf50 !important;
}

.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.podium-container {
  min-height: 240px;
}

.podium-card {
  transition: transform 0.2s ease;
}

.podium-card:hover {
  transform: translateY(-4px);
}

.gold-card {
  background: linear-gradient(180deg, #fffde7 0%, #ffffff 100%);
  border: 2px solid #ffd54f !important;
}

.silver-card {
  background: linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%);
  border: 1px solid #bdbdbd !important;
}

.bronze-card {
  background: linear-gradient(180deg, #efebe9 0%, #ffffff 100%);
  border: 1px solid #d7ccc8 !important;
}

.tabla-compacta >>> td {
  height: 28px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 0.8125rem !important;
}
</style>

<script>
import { reporte_inscripciones_v1 } from './prospectos1/utils';

export default {
  name: 'Ranking2',
  components: {},
  data() {
    return {
      datos_ins: [],
      cargando: false,
      dialogDetalle: false,
      tituloDetalle: '',
      tipoDetalle: '',
      searchDetalle: '',
      ver_tabla_gestionados: false,
      headersDetalle: [
        { text: '#', value: 'index', sortable: false, width: '50px' },
        { text: 'Estudiante', value: 'estudiante_nombre' },
        { text: 'Programa', value: 'programa_nombre' },
        { text: 'Asesor', value: 'asesor_nombre' },
        { text: 'Fecha registro', value: 'fecha_inscripcion', width: '130px' },
        { text: 'Estado adm.', value: 'estado_administrativo_id', width: '130px' },
      ],
      tablaHeaders: [
        { text: 'Posición', value: 'posicion', sortable: false, width: '100px' },
        { text: 'Asesor', value: 'nombre' },
        { text: 'Inscritos', value: 'inscritos', align: 'center' },
        { text: 'Preinscritos', value: 'preinscritos', align: 'center' },
        { text: 'Prospectos', value: 'prospectos', align: 'center' },
        { text: 'Total Gestionados', value: 'total', align: 'center' },
      ],
    };
  },
  computed: {
    // Totales filtrados por estado_administrativo_id
    // 1: Prospecto, 2: Preinscrito, 3: Inscrito
    totalProspectos() {
      return this.datos_ins.filter(item => Number(item.estado_administrativo_id) === 1).length;
    },
    totalPreinscritos() {
      return this.datos_ins.filter(item => Number(item.estado_administrativo_id) === 2).length;
    },
    totalInscritos() {
      return this.datos_ins.filter(item => Number(item.estado_administrativo_id) === 3).length;
    },

    listaDetalle() {
      if (this.tipoDetalle === 'prospectos') {
        return this.datos_ins.filter(item => Number(item.estado_administrativo_id) === 1);
      }
      if (this.tipoDetalle === 'preinscritos') {
        return this.datos_ins.filter(item => Number(item.estado_administrativo_id) === 2);
      }
      if (this.tipoDetalle === 'inscritos') {
        return this.datos_ins.filter(item => Number(item.estado_administrativo_id) === 3);
      }
      return this.datos_ins;
    },
    listaDetalleFiltrada() {
      return this.listaDetalle;
    },

    // Agrupamiento general por asesor
    rankingAsesoresCompleto() {
      const mapaAsesores = {};

      this.datos_ins.forEach(item => {
        const id = item.asesor_id || item.asesor_nombre || 'sin_asesor';
        const nombre = item.asesor_nombre ? item.asesor_nombre.trim() : 'Sin Asesor Asignado';

        if (!mapaAsesores[id]) {
          mapaAsesores[id] = {
            id,
            nombre,
            prospectos: 0,
            preinscritos: 0,
            inscritos: 0,
            total: 0,
          };
        }

        const estadoId = Number(item.estado_administrativo_id);
        if (estadoId === 1) mapaAsesores[id].prospectos++;
        else if (estadoId === 2) mapaAsesores[id].preinscritos++;
        else if (estadoId === 3) mapaAsesores[id].inscritos++;

        mapaAsesores[id].total++;
      });

      // Ordenar por inscritos de forma descendente (y secundariamente por total)
      return Object.values(mapaAsesores).sort((a, b) => {
        if (b.inscritos !== a.inscritos) {
          return b.inscritos - a.inscritos;
        }
        return b.total - a.total;
      });
    },

    // 3 Asesores con mayor cantidad de inscritos
    top3Asesores() {
      return this.rankingAsesoresCompleto
        .filter(asesor => asesor.inscritos > 0)
        .slice(0, 3);
    }
  },
  watch: {
    '$store.state.CARGO': function() {
      this.listenercargo();
    }
  },
  methods: {
    abrirDetalle(tipo) {
      this.tipoDetalle = tipo;
      this.searchDetalle = '';
      if (tipo === 'prospectos') this.tituloDetalle = 'Detalle de Prospectos';
      else if (tipo === 'preinscritos') this.tituloDetalle = 'Detalle de Preinscritos';
      else if (tipo === 'inscritos') this.tituloDetalle = 'Detalle de Inscritos';
      else this.tituloDetalle = 'Detalle Total de Registros';
      this.dialogDetalle = true;
    },
    formatoFecha(f) {
      if (!f) return '-';
      const fs = f.split(/[T ]/)[0].split('-');
      if (fs.length !== 3) return f;
      return `${fs[2]}/${fs[1]}/${fs[0]}`;
    },
    listenercargo() {
      this.get_datos_sede();
    },
    formatoFechaInput(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    async get_datos_sede() {
      this.cargando = true;
      try {
        const idsede = this.$store.state.CARGO?.sede?.id;
        if (!idsede) {
          this.datos_ins = [];
          return;
        }
        const fin = new Date();
        const inicio = new Date();
        inicio.setDate(1);
        const fechaInicio = this.formatoFechaInput(inicio);
        const fechaFin = this.formatoFechaInput(fin);

        const qu = {
          desde: fechaInicio + 'T00:00:00',
          hasta: fechaFin + 'T23:59:59',
          sede_id: [idsede]
        };
        const res = await reporte_inscripciones_v1(qu);
        this.datos_ins = Array.isArray(res) ? res : [];
        window.console.log('Ranking2:::', this.datos_ins);
        this.$emit('loaded-top3', this.top3Asesores);
      } catch (error) {
        window.console.error('Error al obtener datos de sede:', error);
      } finally {
        this.cargando = false;
      }
    },
    parseInsAdministrativo(ins) {
      const estados = {
        1: 'Prospecto',
        2: 'Preinscrito',
        3: 'Inscrito',
        4: 'Inscrito Transferido',
        5: 'Retirado',
        6: 'Retirado Cambiado',
        7: 'Observado',
        8: 'Reincorporado'
      };
      let str = estados[ins] || 'Sin estado';
      return str;
    },
    exportado_top3Asesores(){
      return this.top3Asesores
    }
  },
  mounted() {
    this.get_datos_sede();
  },
};
</script>
